<template>
  <div class="my-4">
    <div class="rounded-md bg-yellow-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <!-- Heroicon name: solid/information-circle -->
          <svg
            class="h-5 w-5 text-yellow-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3 flex-1 md:flex md:justify-between">
          <p class="text-sm text-yellow-700">
            Are you are getting "Phone number shared via url is invalid" while
            you try to send?
          </p>
          <p class="mt-3 text-sm md:mt-0 md:ml-6">
            <a
              class="whitespace-nowrap font-medium text-yellow-700 hover:text-yellow-600 cursor-pointer"
              @click="gotoManualMessageError"
              >View Solution <span aria-hidden="true">&rarr;</span></a
            >
          </p>
        </div>
      </div>
    </div>
    <div v-if="isShopifyWebview" class="rounded-md bg-red-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <!-- Heroicon name: solid/information-circle -->
          <svg
            class="h-5 w-5 text-red-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3 flex-1 md:flex md:justify-between">
          <p class="text-sm text-red-700">
            It seems you are using our app on Shopify mobile app, which will
            block popups by default. So manual messages can't be sent within the
            app. We recommend opening our app in the browser.
          </p>
          <p class="mt-3 text-sm md:mt-0 md:ml-6">
            <a
              class="whitespace-nowrap font-medium text-yellow-700 hover:text-yellow-600"
              :href="authUrl"
              target="_blank"
              >Open in Browser <span aria-hidden="true">&rarr;</span></a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShopifyWebview: false
    };
  },
  computed: {
    userAgent() {
      return navigator.userAgent;
    },
    authUrl() {
      const authToken = window.localStorage.getItem("authToken");
      if (authToken) {
        const origin = window.location.origin;
        return `${origin}?token=${authToken}`;
      }
      return "";
    }
  },
  created() {
    if (this.userAgent.indexOf("Shopify Mobile") > -1) {
      this.isShopifyWebview = true;
      // this.reloadAppToNonEmbeddedMode();
    }
    //
    if (this.userAgent.indexOf("Shopify Mobile") > -1) {
      this.isShopifyWebview = true;
      // this.openAppInBrowser();
    }
  },
  methods: {
    contact() {
      $crisp.push(["do", "chat:open"]); // eslint-disable-line
      // eslint-disable-next-line
      $crisp.push([
        "set",
        "message:text",
        [`Hi, am getting the phone number shared via URL is an invalid error. `]
      ]);
    },
    gotoManualMessageError() {
      this.$router.push({ name: "ManualMessageError" });
    },
    reloadAppToNonEmbeddedMode() {
      const authToken = window.localStorage.getItem("authToken");
      if (authToken) {
        const origin = window.location.origin;

        this.$store.dispatch("appBridgeRedirect", {
          url: `${origin}/#/auth/${authToken}`
        });
      }
    },
    openAppInBrowser() {
      const authToken = window.localStorage.getItem("authToken");
      if (authToken) {
        const origin = window.location.origin;
        window.open(`${origin}?token=${authToken}`, "_blank");
        // this.$store.dispatch("appBridgeRedirect", {
        //   url: `${origin}/#/auth/${authToken}`
        // });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
